import { Grid, Skeleton } from '@mui/material';
import React from 'react';

function LineItemSkeleton() {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Skeleton sx={{ m: 2 }} variant="rectangular" width="25%" height="25" />
        <Skeleton sx={{ m: 2 }} variant="rectangular" width="95%" height="85vh" />
      </Grid>
    </Grid>
  );
}

export default LineItemSkeleton;
